<template>
  <div>
    <div class="home">
      <div id="home-page-header" class="page-header">
        <div class="inner">
        <!-- レッスンを続ける -->
          <div class="flexbox">

            <!-- [style] サムネイル -->
            <div class="homethumb">
              <div class="thumb" :style="{ 'background-image': 'url('+latestJson.thumbnail+')' }"></div>
            </div>

            <!-- [style] レベルタイトル -->
            <div>
              <div class="flexstart">
                <div class="lvl-sorange font12 mr10">レベル {{ latestLevelNo }} </div>
                <div class="lvl-text mbold">ユニット {{ latestUnitNo }} 「{{ latestUnitTitle }}」: レッスン {{ latestLessonIndex+1 }}</div>
              </div>
              <div class="flexstart mt10">
                <div class="font35 mbold mr10">{{ latestPathTitle }}</div><div class="lvl-status" v-if="latestState.length != 0">{{ latestState }}</div>
              </div>
            </div>

            <!-- [style] レッスンを続けるボタン -->
            <button type=button v-on:click="startLesson" class="btn-lblue font25">{{ buttonText }}</button>
          </div><!-- [style] /.flexbox -->

        </div><!-- [style] /.inner -->
      </div><!-- [style] /.page-header -->

      <div class="page-content">
        <div class="inner">
          <!-- アクティビティ一覧 -->
          <div class="actvt-list">
            <div class="actvt-inner">
              <!-- レベル一覧 -->
              <div class="actvt-button" v-for="levelJson in jsonData.levels" :key="levelJson.levelNo">
                <button type=button v-on:click="clickLevel(levelJson.levelNo)" v-if="levelJson.levelNo === currentLevelNo" class="active">レベル{{ levelJson.levelNo }}</button>
                <button type=button v-on:click="clickLevel(levelJson.levelNo)" v-else>レベル{{ levelJson.levelNo }}</button>
              </div>
            </div>
          </div><!-- /.actvt-list -->

          <div class="unit-content">
            <transition name="fade" v-if="isMobile()">
              <div v-show="showUnit" class="inner">
                <!-- 戻る/進む -->
                <div>
                  <div class="slider-prev" v-if="backDisabled"><button type=button v-on:click="backUnit">back</button></div>
                  <div class="slider-next" v-if="goDisabled"><button type=button v-on:click="goUnit">go</button></div>
                </div>

                <!-- slick用ののタグ -->
                <div class="slick-slider">
                  <HomeUnit class="inner slick-item" :currentLevelJson="currentLevelJson" :currentLevelNo="currentLevelNo" :currentUnitNo="currentUnitNo" :currentUnitJson="currentUnitJson" :index="0" @clickLesson="clickLesson" @showLessonDetail="showLessonDetail" @startLessonForMobile="startLessonForMobile" />
                </div>
              </div><!-- /.inner -->
            </transition>
            <div class="inner" v-else>
              <!-- 戻る/進む -->
              <div>
                <div class="slider-prev" v-if="backDisabled"><button type=button v-on:click="backUnit">back</button></div>
                <div class="slider-next" v-if="goDisabled"><button type=button v-on:click="goUnit">go</button></div>
              </div>

              <!-- slick用ののタグ -->
              <div class="slick-slider">
                <div v-for="(n, index) in unitCount" :key="index">
                  <transition name="fade">
                    <HomeUnit v-show="showUnit" class="inner slick-item" :currentLevelJson="currentLevelJson" :currentLevelNo="currentLevelNo" :currentUnitNo="currentUnitNo" :currentUnitJson="currentUnitJson" :index="index" @clickLesson="clickLesson" @showLessonDetail="showLessonDetail" />
                  </transition>
                </div>
              </div>
            </div><!-- /.inner -->
          </div><!-- /.unit-content -->
        </div><!-- /.inner -->
      </div><!-- /.page-content -->
    </div><!-- /.home -->

    <!-- レッスン詳細画面 -->
    <LessonDetail v-if="showLessonDetailFlag" @close="showLessonDetailFlag = false" @clickLessonDetail="clickLesson" :levelNo="lessonDetailLevelNo" :unitNo="lessonDetailUnitNo" :unitTitle="lessonDetailUnitTitle" :lessonIndex="lessonDetailLessonIndex" :lessonJson="lessonDetailLessonJson" @startLessonForMobile="startLessonForMobile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as constants from '@/mixin/constants'
import * as storeConstants from '@/store/constants'
import common from '@/mixin/common'
import http from '@/mixin/http'
import resource from '@/mixin/resource'
import HomeUnit from '@/components/HomeUnit'
import LessonDetail from '@/components/LessonDetail'

export default {
  name: 'home',
  props: {
    jsonData: Object,
    productInfo: Object
  },
  data: function() {
    return {
      // 最後に実施した問題用
      latestLevelNo: 0,
      latestUnitNo: 0,
      latestLessonIndex: 0,
      latestPathIndex: 0,
      latestPathstepIndex: 0,
      latestJson: null,
      buttonText: constants.BUTTON_TEXT_LEVEL,
      latestUnitTitle: '',
      latestPathTitle: '',
      latestState: '',
      // ユニット情報用
      currentLevelNo: 0,
      currentLevelJson: null,
      currentUnitNo: 0,
      currentUnitJson: null,
      showUnit: false,
      unitCount: 0,
      slider: null,
      // ボタン制御用
      backDisabled: false,
      goDisabled: false,
      // レッスン詳細表示用
      showLessonDetailFlag: false,
      lessonDetailLevelNo: 0,
      lessonDetailUnitNo: 0,
      lessonDetailUnitTitle: '',
      lessonDetailLessonIndex: 0,
      lessonDetailLessonJson: null,
    }
  },
  computed: {
    ...mapGetters([
      'progress'
    ])
  },
  mixins: [
    common,
    http,
    resource,
  ],
  components: {
    HomeUnit,
    LessonDetail
  },
  methods: {
    /**
     * Runmodeへ切り替えるため、親へ通知
     */
    emitStartLesson: function() {
      this.log("Home start startLesson")
      this.$emit('startLesson')
    },
    /**
     * 進捗引継ぎ確認画面表示のため、親へ通知
     */
    emitShowProgressHandOver: function(unitNo, lessonIndex, pathIndex, pathstepIndex, json) {
      this.log("Home start emitShowProgressHandOver")
      this.$emit('showProgressHandOver', unitNo, lessonIndex, pathIndex, pathstepIndex, json)
    },
    /**
     * ボタン文言を設定("レベル0を開始する"のレベル番号を設定する)
     */
    setButtonText: function(levelNo) {
      this.buttonText = constants.BUTTON_TEXT_LEVEL.replace(/[\d+]/, levelNo)
    },
    /**
     * ユニットの戻る/進むボタンの有効/無効を設定
     */
    setButtonUnitDisabled: function(levelNo, unitNo) {
      var len = this.jsonData.levels.length
      var minLev = this.jsonData.levels[0]
      var maxLev = this.jsonData.levels[len-1]

      var go = false
      var back = false

      if(minLev.levelNo == levelNo) {
        go = true
        if(minLev.units[0].unitNo != unitNo) {
          back = true
        }
      } else if(maxLev.levelNo == levelNo) {
        back = true
        var unitLen = maxLev.units.length
        if(maxLev.units[unitLen-1].unitNo != unitNo) {
          go = true
        }
      } else {
        go = true
        back = true
      }

      this.backDisabled = back
      this.goDisabled = go
    },
    /**
     * 進捗情報から実行すべき問題を特定する
     */
    setLatestProblem: function(progress){
      this.log("Home start setLatestProblem")

      // 進捗があるか確認
      if(progress.length == 0) {
        // 初めの問題から
        this.log("no progress")

        this.setButtonText(1)
        var lev = this.jsonData.levels[0]
        var unit = lev.units[0]

        // 戻る/進むボタンを設定
        this.setButtonUnitDisabled(lev.levelNo, unit.unitNo)

        this.setCurrentUnitData(lev.levelNo, unit.unitNo, unit)
        this.setLatestData(lev.levelNo, unit.unitNo, 0, 0, 0, unit.lessons[0], unit.title, unit.lessons[0].paths[0].title, '')
        return
      }

      // 最後に実施した問題から
      this.doSetLatestProblem(progress[0], true)
    },
    /**
     *
     */
    doSetLatestProblem: function(progress, setCurrentData) {
      this.log("Home start doSetLatestProblem")

      this.buttonText = constants.BUTTON_TEXT_LESSON

      var latestProKey = Object.keys(progress)
      var latestProSplit = this.splitProgress(progress)
      if(latestProSplit.length != 4) {
        return
      }

      // 表示に必要なデータを設定
      var levelNo = latestProSplit[0]
      var levelJson = this.getLevelJson(this.jsonData, levelNo)
      if(levelJson == null) {
        return
      }

      var unitNo = latestProSplit[1]
      var unitJson = this.getUnitJson(levelJson, unitNo)
      if(unitJson == null) {
        return
      }

      var lesson = latestProSplit[2]
      var path = latestProSplit[3]
      var json = JSON.parse(JSON.stringify(progress))
      var pathstep = Number(json[latestProKey[0]])

      if(setCurrentData) {
        // 戻る/進むボタンを設定
        this.setButtonUnitDisabled(levelNo, unitNo)
        this.setCurrentUnitData(levelNo, unitNo, unitJson)
      }
      this.setLatestData(levelNo, unitNo, lesson, path, pathstep, unitJson.lessons[lesson], unitJson.title, unitJson.lessons[lesson].paths[path].title, constants.LESSON_STATE)
    },
    /**
     * 最後に実施した問題情報を設定
     */
    setLatestData: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, json, unitTitle, pathTitle, state) {
      this.log("Home start setLatestData levelNo: " + levelNo + ", unitNo: " + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex)

      this.latestLevelNo = levelNo
      this.latestUnitNo = unitNo
      this.latestLessonIndex = lessonIndex
      this.latestPathIndex = pathIndex
      this.latestPathstepIndex = pathstepIndex
      this.latestJson = json
      this.latestUnitTitle = unitTitle
      this.latestPathTitle = pathTitle
      this.latestState = state
    },
    /**
     * 表示中のユニット情報を設定
     */
    setCurrentUnitData: function(levelNo, unitNo, unitJson) {
      this.log("Home start setCurrentUnitData levelNo: " + levelNo + ", unitNo: " + unitNo)

      this.currentLevelNo = levelNo
      this.currentLevelJson = this.$store.getters.level({ levelNo: levelNo })
      this.currentUnitNo = unitNo
      this.currentUnitJson = unitJson
    },
    /**
     * レッスン開始
     */
    startLesson: async function() {
      this.log("Home start startLesson")

      // 対象Pathをロードし、Pathstepsを設定する
      var path = this.latestJson.paths[this.latestPathIndex]
      await this.setPathsteps(this.latestLevelNo, this.latestUnitNo, this.latestLessonIndex, path)

      // レッスン情報を保存
      this.setLessonData(this.latestLevelNo, this.latestUnitNo, this.latestLessonIndex, this.latestPathIndex, this.latestPathstepIndex, this.latestJson)

      var params = { levelNo: this.latestLevelNo, unitNo: this.latestUnitNo, lessonIndex: this.latestLessonIndex, pathIndex: this.latestPathIndex, pathsteps: path.pathsteps }

      // スコア更新
      this.$store.dispatch('initPathScore', params)
      this.setStoreCurrentPath(this.$store.getters.score, this.latestLevelNo, this.latestUnitNo, this.latestLessonIndex, this.latestPathIndex)

      // 進捗を確認
      var index = this.$store.getters.filterProgress(params)
      if(index == -1) {
        // 親へ通知
        this.emitStartLesson()
      } else {
        // 進捗引継ぎ確認表示
        this.emitShowProgressHandOver(this.latestUnitNo, this.latestLessonIndex, this.latestPathIndex, this.latestPathstepIndex, this.latestJson)
      }
    },
    /**
     * レッスン開始
     *
     * @param {Number} levelNo レベル番号
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Number} pathIndex PathIndex
     * @param {Number} pathstepIndex PathstepIndex
     */
    startLessonForMobile: async function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex) {
      this.log("Home start startLessonForMobile")

      if (pathstepIndex == -1) {
        pathstepIndex = 0
      }

      // JSONデータを取得
      var levIndex = this.getLevelIndex(this.jsonData, levelNo)
      var unitIndex = this.getUnitIndex(this.jsonData.levels[levIndex], unitNo)
      var lessonJson = this.jsonData.levels[levIndex].units[unitIndex].lessons[lessonIndex]

      // 対象Pathをロードし、Pathstepsを設定する
      var path = lessonJson.paths[pathIndex]
      await this.setPathsteps(levelNo, unitNo, lessonIndex, path)

      // レッスン情報を保存
      this.setLessonData(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson)

      var params = { levelNo: levelNo, unitNo: unitNo, lessonIndex: lessonIndex, pathIndex: pathIndex, pathsteps: path.pathsteps }

      // スコア更新
      this.$store.dispatch('initPathScore', params)
      this.setStoreCurrentPath(this.$store.getters.score, levelNo, unitNo, lessonIndex, pathIndex)

      // 進捗を確認
      var index = this.$store.getters.filterProgress(params)
      if(index == -1) {
        // 親へ通知
        this.emitStartLesson()
      } else {
        // 進捗引継ぎ確認表示
        this.emitShowProgressHandOver(unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson)
      }
    },
    /**
     * レベル選択時の処理
     */
    clickLevel: function(levelNo) {
      this.log("Home start clickLevel: " + levelNo);

      // 表示中のレベルと同じレベルが選択された場合、何もしない
      if (this.currentLevelNo == levelNo) {
        return;
      }

      var levelJson = this.getLevelJson(this.jsonData, levelNo);
      if (levelJson == null) {
        return;
      }

      // フェードイン/フェードアウト
      var self = this;
      this.showUnit = false;
      setTimeout(function() {
        self.doClickLevel(levelNo, levelJson, true);

        // indexを設定
        self.setSliderIndex();

        self.showUnit = true;
      }, 800);
    },
    /**
     *
     */
    doClickLevel: function(levelNo, levelJson, setCurrentData) {
      this.log("Home start doClickLevel: " + levelNo)

      // 選択されたレベルの進捗情報があるか確認
      var pathstepFromLeval = this.$store.getters.filterProgressByLevelNo(levelNo)
      if(pathstepFromLeval == null) {
        // レベルの初めの問題
        this.log("no progress")

        var unit = levelJson.units[0];

        this.setButtonText(levelNo)
        if(setCurrentData) {
          this.setButtonUnitDisabled(levelNo, unit.unitNo)
          this.setCurrentUnitData(levelNo, unit.unitNo, unit)
        }
        this.setLatestData(levelNo, unit.unitNo, 0, 0, 0, unit.lessons[0], unit.title, unit.lessons[0].paths[0].title, '')
        return
      }

      // レベルの最後に実施した問題
      this.doSetLatestProblem(pathstepFromLeval, setCurrentData)
    },
    /**
     * 前のユニット情報を表示
     */
    backUnit: function() {
      this.log("Home start backUnit")

      var levIndex = this.getLevelIndex(this.jsonData, this.currentLevelNo)
      var unitIndex = this.getUnitIndex(this.jsonData.levels[levIndex], this.currentUnitNo)
      this.log("unitIndex: " + unitIndex)

      if(unitIndex == 0) {
        // 1つ前のレベルの最後のユニットを表示
        var level = this.jsonData.levels[levIndex-1]
        var len = level.units.length
        var unit = level.units[len-1]
        this.setCurrentUnitData(level.levelNo, unit.unitNo, unit)
        this.setButtonUnitDisabled(level.levelNo, unit.unitNo)

        // 最後に実施した問題も更新
        this.doClickLevel(level.levelNo, level, false)
      } else {
        // 同じレベルの1つ前のユニット
        var unit = this.jsonData.levels[levIndex].units[unitIndex-1]
        this.setCurrentUnitData(this.currentLevelNo, unit.unitNo, unit)
        this.setButtonUnitDisabled(this.currentLevelNo, unit.unitNo)
      }

      // 前のスライド表示
      this.slider.slick('slickPrev')
    },
    /**
     * 次のユニット情報を表示
     */
    goUnit: function() {
      this.log("Home start goUnit")

      var levIndex = this.getLevelIndex(this.jsonData, this.currentLevelNo)
      var unitIndex = this.getUnitIndex(this.jsonData.levels[levIndex], this.currentUnitNo)
      var unitLen = this.jsonData.levels[levIndex].units.length
      this.log("unitIndex: " + unitIndex + ", unitLen: " + unitLen)

      var unitMax = unitLen - 1
      if(unitIndex == unitMax) {
        // 1つ次のレベルの最初のユニットを表示
        var level = this.jsonData.levels[levIndex+1]
        var unit = level.units[0]
        this.setCurrentUnitData(level.levelNo, unit.unitNo, unit)
        this.setButtonUnitDisabled(level.levelNo, unit.unitNo)

        // 最後に実施した問題も更新
        this.doClickLevel(level.levelNo, level, false)
      } else {
        // 同じレベルの1つ次のユニット
        var unit = this.jsonData.levels[levIndex].units[unitIndex+1]
        this.setCurrentUnitData(this.currentLevelNo, unit.unitNo, unit)
        this.setButtonUnitDisabled(this.currentLevelNo, unit.unitNo)
      }

      // 次のスライド表示
      this.slider.slick('slickNext')
    },
    /**
     * レッスン選択時の処理
     */
    clickLesson: async function(lessonIndex, pathIndex) {
      this.log("Home start clickLesson")
      var self = this

      // 対象Pathをロードし、Pathstepsを設定する
      var path = this.currentUnitJson.lessons[lessonIndex].paths[pathIndex]
      await this.setPathsteps(this.currentLevelNo, this.currentUnitNo, lessonIndex, path)

      // 選択されたpathから、最後に実施したpathStepを取得
      var params = { levelNo: this.currentLevelNo, unitNo: this.currentUnitNo, lessonIndex: lessonIndex, pathIndex: pathIndex, pathsteps: path.pathsteps }
      var pathStepIndex = this.$store.getters.filterProgress(params)
      if(pathStepIndex == -1) {
        pathStepIndex = 0
      }

      // レッスン情報を保存
      this.setLessonData(this.currentLevelNo, this.currentUnitNo, lessonIndex, pathIndex, pathStepIndex, this.currentUnitJson.lessons[lessonIndex])

      // スコア更新
      this.$store.dispatch('initPathScore', params)
      this.setStoreCurrentPath(this.$store.getters.score, this.currentLevelNo, this.currentUnitNo, lessonIndex, pathIndex)

      var state = this.getPathState(lessonIndex, pathIndex)
      if(state === 'go') {
        // 親へ通知
        this.emitStartLesson()
      } else {
        // 進捗引継ぎ確認表示
        this.emitShowProgressHandOver(this.currentUnitNo, lessonIndex, pathIndex, pathStepIndex, this.currentUnitJson.lessons[lessonIndex])
      }
    },
    /**
     * storeの現在Pathレッスンスコアを設定
     */
    setStoreCurrentPath: function(score, levelNo, unitNo, lessonIndex, pathIndex) {
      for(var item of score) {
        var json = JSON.parse(JSON.stringify(item))
        var key = Object.keys(json)
        var split = this.splitScore(json)

        if (split[0] == levelNo && split[1] == unitNo && split[2] == lessonIndex && split[3] == pathIndex) {
          var setParams = ''
          if(split[5] === 'ok') {
            setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ok: Number(json[key[0]])}
          } else if(split[5] === 'ng') {
            setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], ng: Number(json[key[0]])}
          } else {
            setParams = {levelNo: split[0], unitNo: split[1], lessonIndex: split[2], pathIndex: split[3], pathstepIndex: split[4], skip: Number(json[key[0]])}
          }

          // storeへ設定
          this.$store.dispatch('setPathstep', setParams)
        }
      }
    },
    /**
     *　レッスン詳細表示
     */
    showLessonDetail: function(lessonIndex, unitJson) {
      this.log("Home start showLessonDetail")

      if(this.isMobile()) {
        this.lessonDetailLevelNo = this.currentLevelNo
        this.lessonDetailUnitNo = unitJson.unitNo
        this.lessonDetailUnitTitle = unitJson.title
        this.lessonDetailLessonIndex = lessonIndex
        this.lessonDetailLessonJson = unitJson.lessons[lessonIndex]
      } else {
        this.lessonDetailLevelNo = this.currentLevelNo
        this.lessonDetailUnitNo = this.currentUnitNo
        this.lessonDetailUnitTitle = this.currentUnitJson.title
        this.lessonDetailLessonIndex = lessonIndex
        this.lessonDetailLessonJson = this.currentUnitJson.lessons[lessonIndex]
      }

      this.showLessonDetailFlag = true
    },
    /**
     * ステータスを取得
     * 未着手の場合"go"、進行中の場合"going"、全問解答の場合"gone"を返却する
     */
    getPathState: function(lessonIndex, pathIndex) {
      var res = 'go'

      var params = {levelNo: this.currentLevelNo, unitNo: this.currentUnitNo, lessonIndex: lessonIndex, pathIndex: pathIndex}
      var lessonScore= this.$store.getters.path(params)
      switch (lessonScore.status) {
        case storeConstants.PATH_STATE_COMPLETED:
          res = 'gone'
          break
        case storeConstants.PATH_STATE_IN_PROGRESS:
          res = 'going'
          break
        default:
          break
      }

      return res
    },
    /**
     * 開始するレッスン情報を保存
     */
    setLessonData: function(levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, lessonJson) {
      this.log("Home start setLessonData levelNo: " + levelNo + ", unitNo: " + unitNo + ", lessonIndex: " + lessonIndex + ", pathIndex: " + pathIndex + ", pathstepIndex: " + pathstepIndex)
      this.$store.dispatch('setLevelNo', levelNo)
      this.$store.dispatch('setUnitNo', unitNo)
      this.$store.dispatch('setLessonIndex', lessonIndex)
      this.$store.dispatch('setPathIndex', pathIndex)
      this.$store.dispatch('setPathstepIndex', pathstepIndex)
      this.$store.dispatch('setLessonJson', lessonJson)
    },
    /**
     * slider表示用のslickを初期化
     */
    sliderInit: function () {
      this.log("Home start sliderInit")

      this.slider = $('.slick-slider')
      this.slider.slick({
        accessibility: false,
        arrows: false,
        autoplay: false,
        infinite: false,
        swipe: false,
        useCSS: false,
        speed: 300
      })

      // indexを設定
      this.setSliderIndex()
    },
    /**
     * slider表示用のindexを設定
     */
    setSliderIndex: function() {
      if (!this.isEnvironmentPc()) {
        return;
      }
      this.log("Home start setSliderIndex");

      var levelIndex = this.getLevelIndex(this.jsonData, this.latestLevelNo);
      var leveljson = this.getLevelJson(this.jsonData, this.latestLevelNo);
      var index  = this.getUnitIndex(leveljson, this.latestUnitNo);

      if (levelIndex != 0) {
        var count = 0;
        for (var i=0; i < levelIndex; i++) {
          count = count + this.jsonData.levels[i].units.length;
        }
        index = count + index;
      }

      this.slider.slick('slickGoTo', index, true);
    },
    /**
     * 学習状態のAPI送信用のデータを作成
     */
    createStudyStateValue: function() {
      // API送信のデータを作成
      var studyState = this.createStudyStatusDataForApi(false)
      var apiData = '{"data":[' + studyState + ']}'

      return apiData
    },
    /**
    * 学習状態更新
    */
    updateStudyState: function () {
      this.log("Home start updateStudyState")

      var self = this
      var apiData = this.createStudyStateValue()

      this.doSetKeyValue(apiData)
      .then(function(){

        // 学習状態更新
        self.log("set StudyState: " + false)
      })
      .catch(function(message) {
        self.log("set StudyState Error")
      })
    },
    /**
     * key-value設定APIを実行
     */
    doSetKeyValue: function(datajson) {
      this.log("Home start doSetKeyValue")
      var self = this

      return new Promise(function(resolve, reject) {
        // key-value設定API
        self.setKeyValue(self.productInfo.code, datajson)
        .then(function(response) {
          self.log("Home doSetKeyValue resultCode: " + response.result_code)
          switch (response.result_code) {
            case 'OK':
              resolve()
              break
            case 'INFO_INVALID_ACCESSKEY':
              var message = response.result_code;
              reject(message)
              break
            default:
              resolve()
              break
          }
        })
        .catch(function(err) {
          resolve()
        })
      })
    },
    /**
     * 指定されたPathのリソースをロードしてPathstepsを設定する
     *
     * @param {Object} level レベル番号
     * @param {Number} unitNo ユニット番号
     * @param {Number} lessonIndex レッスンIndex
     * @param {Object} path Path要素
     */
    setPathsteps: async function(levelNo, unitNo, lessonIndex, path) {
      if (path.resourceID) {
        var language = this.productInfo.language;
        var level = this.getLevelJson(this.jsonData, levelNo);
        var confuserWordList = this.filterConfuserWordList(level.confuserWordList, unitNo, lessonIndex);
        var pathResource = await this.loadPathResource(path.resourceID, language, level.scriptSystems, confuserWordList);
        path.resourceID = null;
        path.sections = pathResource.sections;
        path.pathsteps = pathResource.pathsteps;
      }
    },
  },
  created: function() {
    this.log("Home start created")

    // モバイルアプリコールバック設定
    if (!this.isEnvironmentPc()) {
      // モバイルアプリ版：端末電源ON時の開始コールバック設定
      ROSETTA_SRE_onStart = function () {}
      // モバイルアプリ版：端末電源OFF時の停止コールバック設定
      ROSETTA_SRE_onStop = function () {}
      // ドコモ版：プッシュ通知ダイアログ終了コールバック設定
      ROSETTA_onPushSetting = function () {}
    }

    document.title = "Rosetta Stone"

    this.showUnit = true

    // 学習状態更新
    this.updateStudyState()

    // 全ユニット数を取得
    var lessonScore = this.$store.getters.lessonScore
    for(var data of lessonScore.levels) {
      this.unitCount = this.unitCount + data.units.length
    }

    // 全ての進捗から、最後に実施した問題を設定
    this.setLatestProblem(this.progress)
  },
  mounted: function() {
    this.log("Home start mounted")

    // 実行環境がモバイルアプリかPCか確認
    if(this.isEnvironmentPc()) {
      // slick初期化
      this.sliderInit()
    }

    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1){
      this.fixtHeightForSafari(120 + 45)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/style/home';

.fade-enter-active, .fade-leave-active {
  transition: opacity .8s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// Home.vue?8a3b2d8a